<template>
    <nav class="board-navigation">
        <router-link active-class="active" to="/sales">
            sale
        </router-link>
        <router-link active-class="active" to="/deliveries">
            delivery
        </router-link>
        <router-link active-class="active" to="/visitors">
            visitors
        </router-link>
    </nav>
</template>

<script>
import '@/scss/Navigation.scss';

export default {
    name: 'NavigationMenu'
}
</script>



// WEBPACK FOOTER //
// src/components/NavigationMenu.vue